/**
 * @fileoverview Table scroll utilities for handling focus events and sticky column width management.
 * Provides functionality to cache sticky column widths and smooth scroll focused cells into view.
 */

let cachedWidth = null;
let lastHeaderText = null;

/**
 * Handles focus events on table input elements by caching sticky column width
 * and smoothly scrolling the focused cell into view.
 * 
 * @param {Event} e - The focus event from an input/select element within a table cell
 * @returns {void}
 */
export const handleTableInputFocus = (e) => {
  const parentCell = e.target.closest('td');
  if (!parentCell || parentCell.cellIndex === 0) return;
  
  const table = parentCell.closest('table');
  if (!table) return;
  
  const firstColumn = table.querySelector('th:first-child, td:first-child');
  
  if (firstColumn) {
    const currentHeaderText = firstColumn.textContent;
    
    if (cachedWidth === null || currentHeaderText !== lastHeaderText) {
      cachedWidth = firstColumn.getBoundingClientRect().width;
      lastHeaderText = currentHeaderText;
      document.documentElement.style.setProperty('--sticky-column-width', cachedWidth + 'px');
    }
  }
  
  setTimeout(() => {
    parentCell.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  }, 0);
};


// WEBPACK FOOTER //
// ./src/utils/tableScrollUtils.js